// cra imports
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals.js';

// import redux requirements
import { Provider } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import { store, persistedStore } from 'store.js';

// import html head tags requirements
import { Helmet } from 'react-helmet';
import { REACT_HELMET_PROPS } from 'config.js';

// import multi language
import LangProvider from 'lang/LangProvider';

// import routing modules
import { BrowserRouter as Router } from 'react-router-dom';
import RouteIdentifier from 'routing/components/RouteIdentifier';
import Loading from 'components/loading/Loading';

// import routes
import { getLayoutlessRoutes } from 'routing/helper';
import defaultRoutes from 'routing/default-routes';
import routesAndMenuItems from 'routes.js';

// import toastify for notification
import { Slide, ToastContainer } from 'react-toastify';
// mock server register for demo
// import '@mock-api';

const Main = () => {
  const layoutlessRoutes = useMemo(() => getLayoutlessRoutes({ data: routesAndMenuItems }), []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <Helmet {...REACT_HELMET_PROPS}>
          <meta name="keywords" content="career, internships, training, workshop, technology, reactjs, nodejs, react, node, python, data science, machine learning, ml, frontend, backend, devops, aws, cloud, azure, gcp, projects" />
          <meta name="title" content="Workabl.in" />
          <meta name="twitter:title" content="Workabl.in" />
          <meta property="og:title" content="Workabl.in" />
          <meta name="description" content="A comprehensive guidance & exposure platform crafted for aspiring IT & software professionals and focussed on building your profile with “learning thats relevant” as per the industry demands, to present you with better job opportunities and consistent career-growth." />
          <meta name="twitter:description" content="A comprehensive guidance & exposure platform crafted for aspiring IT & software professionals and focussed on building your profile with “learning thats relevant” as per the industry demands, to present you with better job opportunities and consistent career-growth." />
          <meta property="og:description" content="A comprehensive guidance & exposure platform crafted for aspiring IT & software professionals and focussed on building your profile with “learning thats relevant” as per the industry demands, to present you with better job opportunities and consistent career-growth." />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image" content="https://console.workabl.in/img/logo/logo-blue-light.png"/>
          <meta property="og:image" content="https://console.workabl.in/img/logo/logo-blue-light.png" />
          <meta property="og:image:secure_url" content="https://console.workabl.in/img/logo/logo-blue-light.png" />
          <meta property="og:url" content="https://workabl.in/" />
          <meta property="og:site_name" content="Workabl.in" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta data-n-head="ssr" data-hid="og:image:type" property="og:image:type" content="image/png" />
          {/* 
          <meta name="twitter:site" content="@user" />
          <meta name="twitter:creator" content="@user" />
          */}
        </Helmet>
        <ToastContainer pauseOnFocusLoss={false} limit={1} transition={Slide} newestOnTop />
        <Router basename={process.env.REACT_APP_BASENAME}>
          <LangProvider>
            <RouteIdentifier routes={[...layoutlessRoutes, ...defaultRoutes]} fallback={<Loading />} />
          </LangProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();
